var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"selectIndex":2}},[_c('carousel'),_c('div',{staticClass:"rwt-portfolio-area rn-section-gap"},[_c('div',{staticClass:"container"},[_c('img',{staticStyle:{"width":"50%","margin":"0px auto","display":"block"},attrs:{"src":require("@/assets/images/img/notice/notice2025-detail.jpg")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }